import { decode as base64_decode, encode as base64_encode } from "base-64";
// import RootStore from './RootStore';
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
// import { act } from 'react-dom/test-utils';
import { message } from "antd";
import config from "../config";

class DriverPerformanceReportStore {
  total = 0;
  driverPerformanceStore = [];
  driverPerformanceArray = [];
  remaning_driverId = "";
  last_record_timestamp = "";
  rootStore;
  loading = false;
  loadingData = false;
  pythonReportMessage = false;
  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      driverPerformanceArray: observable,
      driverPerformanceStore: observable,
      remaning_driverId: observable,
      last_record_timestamp: observable,
      loadData: action,
      driverPerformanceTotal: action,
      loading: observable,
      pythonReportMessage: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    offset,
    limit,
    fromDate,
    toDate,
    pageNo,
  }) {
    this.loading = true;
    // console.log(page)
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=118
      // postData.driverId=[2142]
      // postData.fromDate="2023-01-01 00:00:00"
      // postData.toDate="2023-01-07 12:54:00"
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_driverId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_driverId = this.remaning_driverId;
      }

      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverperformance", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=driver&a=driverPerformance",
          "postData=" + base64Input
        );
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
      this.remaning_driverId = response?.data?.data?.remaning_driverId;
    }
    // console.log(response?.data?.data,"driver")
    this.driverPerformanceStore = response?.data?.data?.driverperformance;

    this.loading = false;
  }

  async driverPerformanceTotal({
    companyId,
    driverId,
    offset,
    limit,
    fromDate,
    toDate,
    page,
  }) {
    if (config.pythonReport !== 1) {
      this.loading = true;
      var postData = {
        companyId: companyId,
        driverName: driverId,
        fromDate: fromDate,
        toDate: toDate,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=driver&a=driverTotalperformance",
          "postData=" + base64Input
        );
      this.driverPerformanceArray = response?.data?.data;
      this.loading = false;
    } else {
      var postData = {
        companyId: companyId,
        driverName: driverId,
        fromDate: fromDate,
        toDate: toDate,
        pageNo: page,
        total: true,
      };
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_driverId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_driverId = this.remaning_driverId;
      }
      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverperformance", postData);
      this.driverPerformanceArray = response?.data?.data;
      this.loading = false;
    }
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverId: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverperformance/download/excel", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportdriverPerformanceExcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.Driver +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverId: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverperformance/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportdriverPerformancePdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.Driver +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportdriverPerformanceCsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.Driver +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportdriverPerformanceXml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.Driver +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default DriverPerformanceReportStore;
